import Sheet from "react-modal-sheet";
import { useDispatch, useSelector } from "react-redux";
import { offCanvasInitialState, selectAskResults, selectQuestionAskedImage, selectQuestionAskedText, updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import SimilarBlock from "../../../Similar/SimilarBlock";
import Image from "next/image";

const AskResults = () => {
  const dispatch = useDispatch();
  const img = useSelector(selectQuestionAskedImage);
  const text = useSelector(selectQuestionAskedText);
  const askResults = useSelector(selectAskResults);

  const MathJaxConfig = {
    loader: { load: ["input/asciimath", "output/chtml"] }
  };

  const resetState = () => {
    dispatch(updateOffCanvasViewPayload({ CAMERA: { ...offCanvasInitialState.data.CAMERA } }));
  }

  return (
    <>
      {
        img && <Image src={img}
          alt="Question Image"
          width={10}
          height={31}
          priority
          className="card w-full max-h-96 object-contain my-0"
        />
      }
      {
        text && <div className="card w-full max-h-96 my-0 flex gap-1">
          <h2>Q:</h2>
          <p>{text}</p>
        </div>
      }
      <Sheet.Scroller className="my-2">
        <MathJaxContext config={MathJaxConfig}>
          <div className="flex flex-col gap-2">
            {
              askResults.map((ques: any) =>
                <MathJax inline dynamic key={ques._id}>
                  <SimilarBlock data={{ ...ques._source, question_id: ques._id }} similarMathJax={ques._source.ocr_text} target="_blank" />
                </MathJax>
              )
            }
          </div>
        </MathJaxContext>
      </Sheet.Scroller>
      <div className="flex justify-center my-4">
        <button className="btn-secondary" onClick={resetState}>Ask another Question</button>
      </div>
    </>
  );
}

export default AskResults;